<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin">
                <span class="loader">
                    <span>{{ $spinnerText }}</span>
                </span>
            </div>
        </Transition>

        <v-form :name="formProps.formName"
                @keyup.enter="autoSave = true">

            <Tabs value="0"
                  scrollable>

                <TabList class="mb-4">
                    <Tab value="0">{{ __('Basic data') }}</Tab>
                    <Tab value="1">{{ __('Changelog') }}</Tab>
                </TabList>

                <TabPanels>
                    <TabPanel value="0">
                        <div class="grid">
                            <FormSelect fieldName="category_id"
                                        label="Category"
                                        validation="required"
                                        size="4"
                                        :isFormDisabled="isFormDisabled"
                                        :options="select?.categories"
                                        v-model:field="crud.category_id" />
                            <FormInputText fieldName="dictionary_name"
                                           label="Dictionary name"
                                           size="6"
                                           validation="required"
                                           :isFormDisabled="isFormDisabled"
                                           v-model:field="crud.dictionary_name" />

                            <FormInputNumber fieldName="order"
                                             label="Order"
                                             size="2"
                                             :allowEmpty="true"
                                             :isFormDisabled="isFormDisabled"
                                             v-model:field="crud.order" />
                        </div>
                    </TabPanel>

                    <TabPanel v-if="crud.log"
                              value="1"
                              :pt="{ root: { class: 'form-tab-panel' } }">
                        <ChangeLog :log="crud?.log" />
                    </TabPanel>
                </TabPanels>
            </Tabs>

            <div class="grid">
                <FormButtons :formProps="props.formProps"
                             :sourceForm="crud"
                             :validation="validation"
                             :buttonsVisibility="buttonsVisibility"
                             v-model:isFormDisabled="isFormDisabled"
                             v-model:autoSave="autoSave">
                </FormButtons>
            </div>
        </v-form>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormSelect from '@crud/FormSelect.vue'
import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import { __, } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(false)
const autoSave = ref(false)

const options = ["categories"];
const select = ref(null);
const crud = ref({})

const buttonsVisibility = ref(null);

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select, buttonsVisibility)
})

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
